export default __webpack_public_path__ + "images/referenzen/produktfilm/caso_produktfilm.mp4";